import { FC, useState } from 'react';
import {
  useDeleteCarsMutation,
  usePutCarsMutation,
} from '../../../../api/carApi';
import Button from '../../../../components/common/Button';
import MenuButton from '../../../../components/common/MenuButton';
import Modal from '../../../../components/common/Modal';
import PolicyRequired from '../../../../components/common/PolicyRequired';
import { Car } from '../../../../types/car';
import { CarFormDataProviderProps } from '../EditSideBar';
import styles from './styles.module.css';
import { logger } from '../../../../services/logger';

type Props = {
  car: Car;
  openEdit: (props: CarFormDataProviderProps | null) => void;
  sidebarClose: () => void;
};
const TableMenuButton: FC<Props> = ({ car, openEdit, sidebarClose }) => {
  const [deleteCar] = useDeleteCarsMutation();
  const [editCar] = usePutCarsMutation();
  const deleteModalContent = (close: () => void) => (
    <div>
      <h3 className={styles.modalHead}>本当に削除しますか？</h3>
      <div className={styles.content}>
        <div className={styles.text}>
          削除すると、元に戻すことはできません。
        </div>
        <div className={styles.controls}>
          <div className={styles.button}>
            <Button variants={['cancel', 'fit']} onClick={close}>
              キャンセル
            </Button>
          </div>
          <div className={styles.button}>
            <Button
              variants={['fit']}
              onClick={async () => {
                await deleteCar(car.carId);
                close();
              }}
            >
              確定
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const openDeleteModal = () => setDeleteModalOpen(true);
  const closeDeleteModal = () => setDeleteModalOpen(false);

  return (
    <>
      <MenuButton>
        {({ close, itemClassName }) => (
          <>
            <PolicyRequired policy={14}>
              <button
                type="button"
                className={itemClassName}
                onClick={() => {
                  openEdit({
                    carId: car.carId,
                    type: 'edit',
                    onSubmit(data) {
                      editCar({ carId: car.carId, data })
                        .then(() => {
                          sidebarClose();
                        })
                        .catch(logger.error);
                    },
                  });
                  close();
                }}
              >
                編集
              </button>
            </PolicyRequired>
            <PolicyRequired policy={15}>
              <button
                type="button"
                className={itemClassName}
                onClick={() => {
                  openDeleteModal();
                  close();
                }}
              >
                削除
              </button>
            </PolicyRequired>
          </>
        )}
      </MenuButton>
      {deleteModalOpen && (
        <Modal onRequestClose={closeDeleteModal}>
          {deleteModalContent(closeDeleteModal)}
        </Modal>
      )}
    </>
  );
};

export default TableMenuButton;
